import useTrailingEntryAndTakeProfit from "@shared/features/tradingTerminal/SmartTrade/useTrailingEntryAndTakeProfit";
import Select from "common/Select/Select";
import React from "react";
import { TrailingEntryAndTakeProfitProps } from "@shared/features/tradingTerminal/common/types";

const TrailingEntryAndTakeProfit = ({
  orderType,
}: TrailingEntryAndTakeProfitProps) => {
  const { options, value, onChange, title } =
    useTrailingEntryAndTakeProfit(orderType);

  const parsedOptions = options?.map(
    (option: { value: number; name: string }) => {
      return {
        value: option.value,
        label: option.name,
      };
    }
  );

  return (
    <Select<number>
      value={value}
      onChange={onChange}
      style={{ width: "100%", marginTop: 8 }}
      options={parsedOptions}
      mobileTitle={title}
    />
  );
};

export default TrailingEntryAndTakeProfit;
